(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-product-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-product-gallery-controls')) {
    customElements.define('tt-product-gallery-controls', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const button = event.target.closest('[data-direction]');
          if (button) this.move(Number(button.dataset.direction));
        };
        this.onKeyDown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeyDown);
      }
      move(direction) {
        const gallery = this.closest('media-gallery');
        const slides = Array.from(gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]'));
        if (slides.length < 2) return;
        const selected = gallery.querySelector('.thumbnail[aria-current="true"]')?.closest('[data-target]')?.dataset.target;
        const current = slides.findIndex((slide) => selected ? slide.dataset.mediaId === selected : slide.classList.contains('is-active'));
        gallery.setActiveMedia(slides[(current + direction + slides.length) % slides.length].dataset.mediaId, false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
